(function () {
  'use strict';


  /* =====================================================
     INITIALIZE ONE ANNOUNCEMENT BAR
     ===================================================== */

  function initAnnouncementBar(bar) {

    if (!bar) {
      return;
    }


    /* Prevent duplicate initialization */

    if (bar.dataset.announcementInitialized === 'true') {
      return;
    }

    bar.dataset.announcementInitialized = 'true';


    /* Get all announcement items */

    const items = Array.from(
      bar.querySelectorAll(
        '[data-announcement-item]'
      )
    );


    /* Nothing to rotate */

    if (items.length === 0) {
      return;
    }


    /* Only one item */

    if (items.length === 1) {

      items[0].classList.add('is-active');

      return;
    }


    /* =================================================
       SETTINGS
       ================================================= */

    const autoplay =
      bar.dataset.autoplay === 'true';


    const speed =
      parseInt(
        bar.dataset.speed,
        10
      ) || 3;


    const delay =
      speed * 1000;


    let currentIndex = 0;

    let timer = null;


    /* =================================================
       SHOW FIRST
       ================================================= */

    items.forEach(function (item, index) {

      item.classList.toggle(
        'is-active',
        index === 0
      );

    });


    /* =================================================
       SHOW NEXT
       ================================================= */

    function showNext() {

      const currentItem =
        items[currentIndex];


      const nextIndex =
        currentIndex + 1 >= items.length
          ? 0
          : currentIndex + 1;


      const nextItem =
        items[nextIndex];


      /*
       * First remove active from current
       */

      currentItem.classList.remove(
        'is-active'
      );


      /*
       * Add active to next
       */

      nextItem.classList.add(
        'is-active'
      );


      /*
       * Update index
       */

      currentIndex = nextIndex;

    }


    /* =================================================
       START
       ================================================= */

    function startRotation() {

      stopRotation();

      timer = setInterval(
        showNext,
        delay
      );

    }


    /* =================================================
       STOP
       ================================================= */

    function stopRotation() {

      if (timer !== null) {

        clearInterval(timer);

        timer = null;

      }

    }


    /* =================================================
       AUTOPLAY
       ================================================= */

    if (autoplay) {

      startRotation();

    }


    /* =================================================
       PAUSE ON HOVER
       ================================================= */

    bar.addEventListener(
      'mouseenter',
      function () {

        stopRotation();

      }
    );


    /* =================================================
       RESUME
       ================================================= */

    bar.addEventListener(
      'mouseleave',
      function () {

        if (autoplay) {

          startRotation();

        }

      }
    );


    /* =================================================
       CLOSE BUTTON
       ================================================= */

    const closeButton =
      bar.querySelector(
        '[data-announcement-close]'
      );


    if (closeButton) {

      closeButton.addEventListener(
        'click',
        function () {

          stopRotation();

          bar.remove();

        }
      );

    }

  }


  /* =====================================================
     INITIALIZE ALL BARS
     ===================================================== */

  function initAllAnnouncementBars() {

    const bars =
      document.querySelectorAll(
        '[data-announcement-bar]'
      );


    bars.forEach(
      function (bar) {

        initAnnouncementBar(bar);

      }
    );

  }


  /* =====================================================
     DOM READY
     ===================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllAnnouncementBars
    );

  } else {

    initAllAnnouncementBars();

  }


  /* =====================================================
     SHOPIFY THEME EDITOR
     ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const bar =
        event.target.querySelector(
          '[data-announcement-bar]'
        );


      if (bar) {

        initAnnouncementBar(bar);

      }

    }
  );


  /* =====================================================
     SHOPIFY SECTION REORDER
     ===================================================== */

  document.addEventListener(
    'shopify:section:reorder',
    function () {

      initAllAnnouncementBars();

    }
  );


})();